import React from "react";
import "./Agency_table.css";
import { useNavigate } from "react-router-dom";

function Agency_table() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Agency_table">
        <div className="commission_table_holder">
          <div class="commission-table">
            <div class="table-column">
              <h3>Direct Subordinates</h3>
              <div class="table-row">
                <p>0</p>
                <span>Number of register</span>
              </div>
              <div class="table-row">
                <p class="green">0</p>
                <span>Deposit number</span>
              </div>
              <div class="table-row">
                <p class="orange">0</p>
                <span>Number of People making first deposit</span>
              </div>
            </div>

            <div class="table-column">
              <h3>Team Subordinates</h3>
              <div class="table-row">
                <p>0</p>
                <span>Number of register</span>
              </div>
              <div class="table-row">
                <p class="green">0</p>
                <span>Deposit number</span>
              </div>
              <div class="table-row">
                <p class="orange">0</p>
                <span>Number of People making first deposit</span>
              </div>
            </div>
          </div>
          <button class="btn_register_bg " onClick={() => navigate("/invite")}>
            Download QR code
          </button>
        </div>
      </section>
    </>
  );
}

export default Agency_table;
